import React, { useEffect, useRef } from 'react';
import './Pagination.css';

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

function Pagination({ currentPage, totalPages, onPageChange }: PaginationProps) {
  const prevPageRef = useRef(currentPage);

  useEffect(() => {
    if (prevPageRef.current !== currentPage) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      prevPageRef.current = currentPage;
    }
  }, [currentPage]);

  if (totalPages <= 1) {
    return null;
  }

  const handlePageChange = (page: number) => {
    onPageChange(page);
  };

  return (
    <div className="pagination">
      <button
        className="pagination-btn"
        onClick={() => handlePageChange(1)}
        disabled={currentPage === 1}
        title="Primeira página"
      >
        ««
      </button>
      <button
        className="pagination-btn"
        onClick={() => handlePageChange(currentPage - 1)}
        disabled={currentPage === 1}
        title="Página anterior"
      >
        ‹
      </button>
      
      <span className="pagination-info">
        Página {currentPage} de {totalPages}
      </span>
      
      <button
        className="pagination-btn"
        onClick={() => handlePageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        title="Próxima página"
      >
        ›
      </button>
      <button
        className="pagination-btn"
        onClick={() => handlePageChange(totalPages)}
        disabled={currentPage === totalPages}
        title="Última página"
      >
        »»
      </button>
    </div>
  );
}

export default Pagination;

